// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"308":"quote","571":"settings","718":"design-project","810":"production-order"}[chunkId] || chunkId) + "." + {"308":"85bc608f","341":"6531b72b","396":"b7e5b72d","571":"d8d159a6","713":"9eadb922","718":"5ca4379c","810":"d251deaa"}[chunkId] + ".js";
};